import { NavRoutes } from "../enums/header-items";

export const navItems = Object.entries(NavRoutes).map(([key, value]) => ({
  name: key,
  path: value,
}));
